const name = process.env.REACT_APP_BASE_URL;
export const basePath = name || '/';